<template>
	<div class="page" style="background-image: url(./images/form_bg.png); background-size: cover; overflow: auto;">

		<van-cell-group v-if="stuForm.id">
			<div style="background-color: #f7f8fc; padding: 10px; font-size: 12px; font-weight: bold;">
				<span class="rowlabel"></span>审核状态
			</div>
			<div style="padding: 20px; font-size: 14px; position: relative;" @click="goBaoming">
				<div style="font-weight: bold;">
					我的报名 <span v-if="stuForm.status!=1" style="color: orangered;">点击修改报名信息</span>
				</div>
				<div style="padding-top: 10px; color: #888;">
					提交时间：{{stuForm.cdate}}
				</div>

				<div style="position: absolute; top: 10px; right: 30px; width: 60px;">
					<img v-if="stuForm.status==0" src="//aiwx.org.cn/static/icon/static/sp_normal.png"
						style="width: 100%;">
					<img v-if="stuForm.status==1" src="//aiwx.org.cn/static/icon/static/sp_over.png"
						style="width: 100%;">
					<img v-if="stuForm.status==-1" src="//aiwx.org.cn/static/icon/static/sp_fail.png"
						style="width: 100%;">

				</div>
				<div style="font-size: 12px; color: orangered;" v-if="stuForm.status==-1">
					{{stuForm.sp_word}}
				</div>

			</div>

			<div style="background-color: #f7f8fc; padding: 10px; font-size: 12px; font-weight: bold;">
				<span class="rowlabel"></span>报名信息
			</div>

			<van-field readonly v-model="stuForm.stu_name" label="考生姓名" label-width="110px" />
			<!-- <van-field readonly v-model="stuForm.archive" label="建档号" label-width="110px" /> -->
			<van-field readonly v-model="stuForm.exam_num" label="学号" label-width="110px" />
			<van-field readonly v-model="stuForm.phone" label="手机号" label-width="110px" />
			<van-field readonly :value="stuForm.identity_card" label="身份证号" label-width="110px" />
			<van-field readonly v-model="stuForm.birthday" label="出生年月" label-width="110px" />
			<van-field readonly :value="stuForm.gender==1?'男':'女'" label="性别" label-width="110px" />
			<van-field readonly :value="stuForm.otherjson.a_score" label="中考一模成绩" label-width="110px" />
			<van-field readonly :value="stuForm.otherjson.b_score" label="中考二模成绩" label-width="110px" />
			<van-field readonly :value="stuForm.exam_score" label="中考成绩" label-width="110px" />
			<!-- <van-field readonly v-model="stuForm.minzu" label="民族" label-width="110px" /> -->

			<!-- <van-field readonly v-model="stuForm.hkszd" label="户口所在" label-width="110px" /> -->
			<van-field readonly v-model="stuForm.jtzz" label="现居住地址" label-width="110px" />
			<van-field readonly v-model="stuForm.graduate_sch_city" label="毕业地区" label-width="110px" />
			<van-field readonly v-model="stuForm.graduate_schname" label="毕业学校" label-width="110px" />

			<van-field readonly v-model="stuForm.major.title" label="第二批次:" label-width="110px" />
			<van-field readonly v-model="stuForm.major.item_desc" label="学制" label-width="110px" />
			<van-field readonly :value="stuForm.otherjson.major_tj1==1?'是':'否'" label="服从调剂" label-width="110px" />
			
			<van-field readonly v-model="stuForm.major.title" label="第二批次:" label-width="110px">
				<template #input>
					{{stuForm.major2?stuForm.major2.title:''}}
				</template>
			</van-field>
			<van-field readonly v-model="stuForm.major.item_desc" label="学制" label-width="110px">
				<template #input>
					{{stuForm.major2?stuForm.major2.item_desc:''}}
				</template>
			</van-field>
			<van-field readonly :value="stuForm.otherjson.major_tj2==1?'是':'否'" label="服从调剂" label-width="110px" />
			
			
			<van-field readonly v-model="stuForm.major.title" label="第三批次:" label-width="110px">
				<template #input>
					{{stuForm.major3?stuForm.major3.title:''}}
				</template>
			</van-field>
			<van-field readonly v-model="stuForm.major.item_desc" label="学制" label-width="110px">
				<template #input>
					{{stuForm.major3?stuForm.major3.item_desc:''}}
				</template>
			</van-field>
			<van-field readonly :value="stuForm.otherjson.major_tj3==1?'是':'否'" label="服从调剂" label-width="110px" />

			<van-field readonly v-model="stuForm.jhr1name" label="监护人" label-width="110px" />
			<van-field readonly v-model="stuForm.jhr1phone" label="电话" label-width="110px" />



			<van-field readonly :value="stuForm.otherjson.tjr" label="推荐老师" label-width="110px" />

			<van-field readonly v-model="stuForm.graduate_schname" label="是否住宿" label-width="110px">
				<template #input>
					{{stuForm.dorm?'是':'否'}}
				</template>
			</van-field>
			<!-- <van-field readonly v-model="stuForm.graduate_schname" label="户口簿/身份证" label-width="110px">
				<template #input>
					<div style="width: 50%; margin: 0 auto;">
						<img :src="stuForm.otherjson.identity_card1||stuForm.otherjson.hkb" style="width: 100%;" />
					</div>

				</template>
			</van-field>
			<van-field readonly v-model="stuForm.graduate_schname" label="准考证照片" label-width="110px">
				<template #input>
					<div style="width: 50%; margin: 0 auto;">
						<img :src="stuForm.otherjson.zkz" style="width: 100%;" />
					</div>

				</template>
			</van-field>
			<van-field readonly v-model="stuForm.graduate_schname" label="分数条" label-width="110px" >
				<template #input>
					<div  style="width: 50%; margin: 0 auto;">
						<img :src="stuForm.otherjson.score" style="width: 100%;" />
					</div>
					
				</template>
			</van-field> -->
			<div style="height: 50px;">

			</div>
		</van-cell-group>


	</div>
</template>

<script>
	import {
		Dialog,
		Toast,
		Uploader
	} from 'vant';
	export default {
		data() {
			return {

				stuForm: {
					ly_type: "",
					stu_name: "",
					archive: "",
					identity_card: "",
					phone: "",
					gender: "",
					exam_score: "",
					graduate_sch_city: "",
					graduate_schid: -1,
					graduate_schname: "",
					graduate_schname2: "",
					graduate_dist_code: "",
					major_id: "",
					major_id2: '',
					major_id3: '',
					major_name: "",
					major_name2: "",
					major_name3: "",
					volunteer: '',
					volunteerTxt: "",
					oldname: '',
					exam_num: '',
					remark: "",
					jhr1name: "",
					jhr1phone: "",
					jhr2name: "",
					jhr2phone: "",
					minzu: "",
					zzmm: "",
					jiguan: "",
					hkszd: "",
					hkszdpcs: "",
					hkxz: "",
					jzdtype: "",
					jtzz: "",


				},

			}
		},
		mounted() {
			$(".page").height($(window).height())
			document.title = "报名详情"
			this.pmid = this.$route.query.pmid
			this.openid = this.$route.query.openid
			if (!this.openid) {
				Dialog.alert({
					title: '网络错误',
					message: '未获取到微信授权用户信息，请重新扫码！',
					theme: 'round-button',
				}).then(() => {
					// on close
				});
			} else {
				window.pmid = this.pmid
				this.getStudents()

			}





		},
		methods: {
			goBaoming() {
				if (this.stuForm.status != 1) {
					this.$router.push("/bk?pmid=" + this.pmid + "&openid=" + this
						.openid)
				}
			},
			getStudents() {

				this.$http.post("/api/app_stuinfo", {
					pmid: this.pmid,
					openid: this.openid
				}).then(res => {
					if (res.data) {


						res.data.otherjson = JSON.parse(res.data.otherjson)
						this.stuForm = res.data

					} else {
						Dialog.alert({
							title: '提示',
							message: '未找到报名信息！',
							theme: 'round-button',
						}).then(() => {
							// on close
						});
					}



				})
			},

		},
	}
</script>
<style type="text/css" scoped="scoped">
	.rowlabel {
		display: inline-block;
		width: 6px;
		border-radius: 3px;
		height: 14px;
		float: left;
		background: #1283ff;
		vertical-align: middle;
		transform: translateY(2px);
		margin-right: 5px;
	}
</style>
